import {IProjectItem} from "../../types/IProjectItem";
import ButtonGroup from "../partials/ButtonGroup";
import ProjectTechStack from "./partials/ProjectTechStack";
import ProjectDuration from "./partials/ProjectDuration";
import {richTextResolver} from "@storyblok/richtext";

export default function ProjectStyle2({item, year}: { item: IProjectItem, year: number|string }) {
    const { render } = richTextResolver()

    const buttons = <ButtonGroup buttons={item.content?.buttons ?? []}/>

    return <section key={item.uuid} id={`year-${year}`} className={"py-5 project-style-2"}>
        <div className="mx-auto w-full">
            <div className="lg:grid lg:grid-cols-5 lg:items-start lg:gap-24">
                <div className="relative z-10 col-span-5">
                    <div className="mx-auto max-w-prose text-base lg:max-w-none">
                        <h2 className="text-lg font-semibold text-secondary">
                           <ProjectDuration item={item} />
                        </h2>
                        <p className="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
                            {item.content.title}
                        </p>
                    </div>
                    <div className="relative z-10 mx-auto max-w-prose text-base lg:mx-0 lg:max-w-5xl lg:pr-72">
                        <p className="text-lg text-gray-500">
                            {item.content.subtitle}
                        </p>
                    </div>

                    <div className="prose prose-secondary mx-auto text-gray-500 lg:max-w-none rich-text">
                        <div className=""
                             dangerouslySetInnerHTML={{
                                 __html: render(item.content.description) as string
                             }}
                        >
                        </div>
                    </div>

                    <ProjectTechStack className={'mt-6'} items={item.content.technologies}/>


                    <div className="mx-auto mt-10 flex max-w-prose text-base lg:max-w-none gap-4">
                        {buttons}
                    </div>
                </div>
            </div>
        </div>

    </section>
}